import { render, staticRenderFns } from "./CustomDialogs.vue?vue&type=template&id=6d9b035a&scoped=true"
import script from "./CustomDialogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomDialogs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomDialogs.vue?vue&type=style&index=0&id=6d9b035a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.1_webpack@5.74.0_esbuild@0.28.1___lodash@4.17.21_pret_109f61365412ffe5355524363be3c32c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b035a",
  null
  
)

export default component.exports